import { createReducer } from '@reduxjs/toolkit';
import { addToast, removeToast } from './toasts.actions';

const initialState = {
  items: []
};

const toastReducer = createReducer(initialState, builder => {
  builder
    .addCase(addToast, (state, action) => {
      state.items.push(action.payload);
    })
    .addCase(removeToast, (state, action) => {
      if (typeof action.payload === 'undefined') {
        state.items = [];
        return;
      }

      const index = state.items.findIndex(item => item.id === action.payload);
      if (index >= 0) {
        state.items.splice(index, 1);
      }
    });
});

export default toastReducer;
